export const API_GET_TIGERCAT_BURNS_GET_BIOCHAR_VOLUMES = 'api/tigercat-burns/biochar-volumes';

export const API_GET_TIGERCAT_BURNS_GET_BIOCHAR_COLLECTION = 'api/tigercat-burns/biochar-collections';

export const API_GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS = 'api/tigercat-burns/get-biochar-mass-bags';
export const API_POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT = 'api/tigercat-burns/post-biochar-mass-moisture-content';

export const API_POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY = 'api/tigercat-burns/create-bulk-fuel-delivery';
export const API_GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY = 'api/tigercat-burns/get-bulk-fuel-delivery';

export const API_POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE = 'api/tigercat-burns/create-biochar-production-fuel-use';
export const API_GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE = 'api/tigercat-burns/get-biochar-production-fuel-use';

export const API_GET_TIGERCAT_BURNS_FEEDSTOCK_PROCESSING_FUEL = 'api/tigercat-burns/get-feedstock-processing-fuel';

export const API_POST_TIGERCAT_BURNS_POST_PROPANE_REFILL = 'api/tigercat-burns/create-propane-refill';
export const API_GET_TIGERCAT_BURNS_GET_PROPANE_REFILL = 'api/tigercat-burns/get-propane-refill';

export const API_POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT = 'api/tigercat-burns/post-feedstock-transport';
export const API_GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT = 'api/tigercat-burns/get-feedstock-transport';

export const API_POST_TIGERCAT_BURNS_ADD_BASE_CALLER = 'api/tigercat-burns/add-base-caller';
export const API_GET_TIGERCAT_BURNS_GET_BASE_CALLERS = 'api/tigercat-burns/get-base-callers';
export const API_POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION = 'api/tigercat-burns/add-call-submission';
export const API_GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG = 'api/tigercat-burns/get-call-submission-log';

export const API_POST_TIGERCAT_BURNS_POST_BIOCHAR_MC = 'api/tigercat-burns/post-biochar-moisture-content';
export const API_GET_TIGERCAT_BURNS_GET_BIOCHAR_MC = 'api/tigercat-burns/get-biochar-moisture-content';

export const API_POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT = 'api/tigercat-burns/create-equipment-transport';
export const API_GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT = 'api/tigercat-burns/get-equipment-transport';

export const API_TELEMATICS_ACTIVITY_DATA = 'api/tigercat-burns/telematics-activity-data';
export const API_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT = 'api/tigercat-burns/telematics-activity-data-for-equipment';

export const API_GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT = 'api/tigercat-burns/download-document';

export const API_POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES = 'api/tigercat-burns/post-biochar-lab-samples';
export const API_GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES = 'api/tigercat-burns/get-biochar-lab-samples';

export const API_POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS = 'api/tigercat-burns/post-biochar-lab-samples-contaminants';
export const API_GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS = 'api/tigercat-burns/get-biochar-lab-samples-contaminants';

export const API_POST_FEEDSTOCK_MOISTURE_CONTENT = 'api/tigercat-burns/post-feedstock-moisture-content';
export const API_GET_FEEDSTOCK_MOISTURE_CONTENT = 'api/tigercat-burns/get-feedstock-moisture-content';
export const API_GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES = 'api/tigercat-burns/get-feedstock-moisture-content-averages';